/**
 * The user’s current browser timezone.
 */
export const timezone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
